import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UserAuthInterceptor implements HttpInterceptor {

    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
        null
    );
    constructor(private router: Router, private injector: Injector) { }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('token');
        const re = "api/token";
        const savaRe = 'https://savaapihub.sava-osiguranje.co.rs:8081/API/ExchangeRate'
        const kursna = 'api.kursna-lista.info'
        // console.log(req.url.split('/'))
        if (req.url.split('?')[0] != re) {
            if (token) {
                const cloned = req.clone({
                    setHeaders: {
                        Authorization: 'bearer ' + token
                    }
                })
                // console.log(cloned)
                return next.handle(cloned).pipe(catchError(
                    (error) => {
                        if (error.status == 401) {
                            localStorage.removeItem('token');
                            this.router.navigateByUrl('');
                        }
                        return throwError(error);
                    }
                ))
            } else {
                // console.log(req)
                return next.handle(req).pipe(catchError(
                    (error) => {
                        if (error.status == 401) {
                            localStorage.removeItem('token');
                            this.router.navigateByUrl('');

                        }
                        return throwError(error);
                    }
                ))
            }
        }
        // console.log(req)
        return next.handle(req);
    }


}